<template>
  <div>
    <!-- 特殊电教馆账号 -->
    <template v-if="ifReviewAccount">
      <div
        class="review-course"
        v-if="(courseList && courseList.length) || courseLoading"
      >
        <div class="list_title_bar">
          <div class="list_logo">
            <img
              src="@/assets/icons/topic_index_icon.png"
              class="list_title_icon"
            />
            精品课程
          </div>
          <div class="list_tool_bar">
            <div class="list_input_wrap">
              <el-input
                class="input list_search_input"
                placeholder="请输入课程名称"
                @clear="toSearch()"
                @keyup.enter.native="toSearch()"
                clearable
                v-model="keywords"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="toSearch()"
                />
              </el-input>
            </div>
            <div class="list_more" @click="handleNavigatorItemClick(',ALL')">
              全部课程<i class="el-icon-arrow-right" />
            </div>
          </div>
        </div>

        <div v-if="courseLoading">
          <LoadingList :listLenth="9" />
        </div>
        <div v-else>
          <div class="main_list">
            <a
              class="course_item"
              v-for="(item, index) in courseList"
              :key="index"
              href="#"
              @click.prevent="jumpTo(item)"
            >
              <div class="course_cover_wrap">
                <el-image
                  class="course_cover"
                  :src="getCover(item.webSmallCoverImgUrls)"
                  fit="cover"
                >
                  <div class="error_img" slot="error" />
                </el-image>
                <Tag
                  class="course_tag"
                  :text="rangeType(item)"
                  color="#FFFFFF"
                  background="rgba(0,0,0,0.6)"
                  no-radius="bottom-left"
                />
              </div>
              <div class="course_info">
                <div class="course_title">
                  {{ item.name }}
                </div>
                <div class="course_intro">
                  <div class="course_type">分类：{{ item.courseTypeName }}</div>
                  <div class="course_grade">
                    年级：{{ getGrade(item.courseGradeTermList) }}
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="main_wrap">
        <div class="to-top" v-show="toTopShow" @click="toTop">
          <span>去顶部</span>
        </div>
        <div class="guest_tips_wrap" v-if="!loginStatus">
          <div class="guest_tips">
            <img src="@/assets/icons/icon_tips.png" alt="" />
            当前处于游客模式，可体验部分内容；如需查看所有内容，请使用教师账号进行
            <router-link to="/login">登录</router-link>
          </div>
        </div>
        <!-- 广告 -->
        <div class="advertisement">
          <el-carousel :interval="5000" trigger="click">
            <el-carousel-item v-for="item in adList" :key="item.id">
              <el-image
                class="advertisement-item"
                @click="toAdvertisement(item)"
                :src="item.adImgUrl"
                fit="cover"
              >
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <template v-if="!courseLoading">
          <!-- 课程分类 -->
          <div
            class="category_bar_box"
            v-if="(courseList && courseList.length) || courseLoading"
            id="logo"
          >
            <div class="total-category-bar">
              <div class="category-bar">
                <img
                  src="@/assets/images/logo_alt.png"
                  class="logo"
                  v-show="logoShow"
                />
                <div
                  v-for="(item, index) in courseList"
                  class="category-item"
                  :class="{ active: allCategoryActive == index }"
                  @click="goAnchor(item)"
                  :key="index"
                >
                  <el-image
                    class="category-icon"
                    :src="require(`@/assets/icons/icon_${item.type}.png`)"
                    fit="cover"
                  >
                  </el-image>
                  {{ item.typeName }}
                </div>
              </div>
              <div class="list_tool_bar">
                <div class="list_input_wrap">
                  <el-input
                    class="input list_search_input"
                    placeholder="请输入课程或资源名称"
                    @clear="toSearch()"
                    @keyup.enter.native="toSearch()"
                    clearable
                    maxlength="20"
                    v-model="keywords"
                  >
                    <i
                      slot="prefix"
                      class="el-input__icon el-icon-search"
                      @click="toSearch()"
                    />
                  </el-input>
                </div>
                <div
                  class="list_more"
                  @click="handleNavigatorItemClick(',ALL')"
                >
                  全部课程 >
                </div>
              </div>
            </div>
            <div
              class="province-category-bar"
              v-show="detailCategoryActive != null"
            >
              <template v-if="courseList[0]">
                <div
                  v-for="(item, index) in courseList[0].childrenType"
                  class="category-item"
                  :class="{ active: detailCategoryActive == index }"
                  @click="goAnchor(item)"
                  :key="index"
                >
                  {{ item.typeName }}
                </div>
              </template>
            </div>
          </div>
          <!-- 透明占位块，防止详细分类，即province-category-bar消失时，监听屏幕滚轮的头部突然落下 -->
          <div class="opacity-bar" v-show="detailCategoryActive == null"></div>
          <div v-for="(item, index) in courseList" :key="index">
            <!-- 存在子类，即省精品下的六大类 -->
            <template v-if="item.childrenType.length > 0">
              <div
                class="course-category-item anchor-point"
                v-for="(secItem, secIndex) in item.childrenType"
                :key="secIndex"
                :id="secItem.type"
              >
                <div class="course-category-item-header">
                  <el-image
                    class="icon"
                    :src="require(`@/assets/icons/icon_${secItem.type}.png`)"
                    fit="cover"
                  >
                  </el-image>
                  <span class="title">
                    <div class="name">{{ secItem.typeName }}</div>
                    <div class="tip">{{ getCategoryTip(secItem.type) }}</div>
                  </span>
                  <div
                    class="more"
                    v-if="secItem.provinceCourseVoList.length >= 8"
                    @click="
                      handleNavigatorItemClick(`${item.type},${secItem.type}`)
                    "
                  >
                    查看更多 >
                  </div>
                </div>
                <div class="category-item-content">
                  <div
                    class="category-wrap"
                    :style="{
                      background: `url(${require(`@/assets/images/image_${secItem.type}.png`)})`,
                      color: getCategoryColor(secItem.type),
                    }"
                    @click="
                      handleNavigatorItemClick(`${item.type},${secItem.type}`)
                    "
                  >
                    <div class="category-name">{{ secItem.typeName }}</div>
                    <div class="course-num">
                      共{{ secItem.provinceCourseVoList.length }}门课程 >
                    </div>
                  </div>
                  <div class="course-list">
                    <!-- thirdItem是课程 -->
                    <div
                      class="course-item"
                      v-for="(
                        thirdItem, thirdIndex
                      ) in secItem.provinceCourseVoList.slice(0, 8)"
                      @click="jumpTo(thirdItem)"
                      :key="thirdIndex"
                    >
                      <div class="course-wrap">
                        <el-image
                          class="course_cover"
                          :src="getCover(thirdItem.webSmallCoverImgUrls)"
                          fit="cover"
                        >
                          <div class="error_img" slot="error" />
                        </el-image>
                      </div>
                      <div class="course-title">{{ thirdItem.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!-- 不存在子类的另外三大类 -->
            <template v-else>
              <div
                class="hollow-category-item anchor-point"
                :style="{
                  backgroundImage: `url(${require(`@/assets/images/image_${item.type}.png`)})`,
                  backgroundColor: categoryBackMap[item.type]
                }"
                :id="item.type"
              >
                <div class="hollow-category-item-header">
                  <div class="title">{{ item.typeName }}</div>
                  <div
                    class="more"
                    v-if="item.provinceCourseVoList.length >= 4"
                    @click="handleNavigatorItemClick(item.type)"
                  >
                    查看更多 >
                  </div>
                </div>
                <!-- 作业辅导课类型有单独的处理 -->
                <div
                  class="homework-course"
                  v-if="item.type == 'HomeworkGuide'"
                >
                  <el-image
                    class="course-wrap"
                    :src="homeworkURL"
                    fit="contain"
                  >
                  </el-image>
                  <div class="video-dialog" @click="changeDialogShow(true)">
                    <div
                      class="video-bg"
                      v-if="homeworkVedioShow"
                      @click.stop="changeDialogShow(false)"
                    >
                      <div
                        class="video-element-wrap"
                        @click.stop="changeDialogShow(true)"
                      >
                        <div
                          class="icon-close"
                          @click.stop="changeDialogShow(false)"
                        >
                          <el-image
                            class="course_cover"
                            :src="
                              require(`@/assets/icons/icon_dialog_close.png`)
                            "
                            fit="cover"
                          >
                          </el-image>
                        </div>
                        <video class="video-element" controls autoplay>
                          <source
                            :src="item.provinceCourseVoList[0].introVideo"
                          />
                          对不起，您的浏览器不支持播放该视频
                        </video>
                      </div>
                    </div>
                  </div>
                  <div
                    class="course-button"
                    @click="handleNavigatorItemClick(item.type)"
                  ></div>
                </div>
                <div
                  v-else-if="item.provinceCourseVoList.length > 0"
                  class="course-list"
                >
                  <!-- secItem是课程 -->
                  <div
                    class="course-item"
                    v-for="(
                      secItem, secIndex
                    ) in item.provinceCourseVoList.slice(0, 4)"
                    @click="jumpTo(secItem)"
                    :key="secIndex"
                  >
                    <div class="course-wrap">
                      <el-image
                        class="course_cover"
                        :src="getCover(secItem.webSmallCoverImgUrls)"
                        fit="cover"
                      >
                        <div class="error_img" slot="error" />
                      </el-image>
                    </div>
                    <div class="course-info">
                      <div class="course-title">{{ secItem.name }}</div>
                      <div class="course-detail">
                        {{ secItem.summary || "" }}
                      </div>
                      <div class="course-grade">
                        <div class="grade">
                          年级：{{ getGrade(secItem.courseGradeTermList) }}
                        </div>
                        <span>浏览量：{{ secItem.viewCount }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="course-empty">
                    <Empty text="内容更新中" />
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- 专题 -->
          <!-- <div class="topic" v-if="(loginStatus && topicHandle) || topicLoading">
      <div class="topic_title">
        <div class="topic_title_text">专题资源</div>
        <div
          class="topic_title_more"
          @click="toMoreTopic()"
          v-if="topicTotal > 4"
        >
          更多专题
          <img class="topic_title_more_icon" :src="ICON_ArrowRight" />
        </div>
        <div v-else></div>
      </div>
      <div class="main_list topic_list topic_loading" v-if="topicLoading">
        <TopicCardLoading v-for="(item, index) in 4" :key="index" />
      </div>
      <div v-else>
        <div v-if="topicList.length > 0">
          <div class="topic_list main_list">
            <a
              class="topic_item"
              v-for="(item, index) in topicList"
              :key="index"
              href="javascript:;"
              @click.prevent="jumpTopic(item)"
            >
              <topic-card :topicData="item" />
            </a>
          </div>
        </div>
        <div class="topic_list empty" v-else>
          <empty height="34rem" />
        </div>
      </div>
    </div> -->
        </template>
        <template v-else>
          <HomeLoading />
        </template>
        <div class="intro">
          <el-image class="course_cover" :src="introURL" fit="cover">
            <div class="error_img" slot="error" />
          </el-image>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { getGrade, getRangeType } from "@/utils/common";
import {
  getHomeAdBanner,
  getHomeCourseList,
  getGuestHomeCourseList,
  getSystemConfig,
  getSearchDisc,
  getTopicList,
  getPageList,
} from "@/api/course";
import { bindWx, getUserInfo } from "@/api/user";
import LoadingList from "@/components/loadingList.vue";
// import ICON_ArrowRight from "@/assets/icons/icon_arrow_right.png";
import Tag from "@/components/tag";
import Empty from "@/components/empty.vue";
import HomeLoading from "@/components/homeLoading.vue";
// import TopicCard from "@/components/topicCard.vue";
// import TopicCardLoading from "@/components/topicCardLoading.vue";

@Component({
  components: {
    Tag,
    Empty,
    LoadingList,
    HomeLoading,
    // TopicCard,
    // TopicCardLoading,
  },
  filters: {
    UpcaseFilter(val) {
      if (typeof val == "string") return val.toUpperCase();
      else return val;
    },
  },
})
export default class CourseIndexPage extends Vue {
  userCode = null;

  //去顶部是否展示
  toTopShow = null;
  //分类logo是否展示
  logoShow = null;
  //作业辅导课视频出现标志
  homeworkVedioShow = false;

  //广告
  adList = [];

  // 课程
  courseList = [];
  courseLoading = null;

  //图片url地址
  homeworkURL =
    "https://oss.zqkh.com.cn/afterclass_app/teacher_pc_images/video_HomeworkGuide.png?x-oss-process=image/auto-orient,1/sharpen,100/quality,q_80/format,webp";
  introURL =
    "https://oss.zqkh.com.cn/afterclass_app/teacher_pc_images/image_home_bottom.png?x-oss-process=image/auto-orient,1/sharpen,100/quality,q_80/format,webp";

  //锚点定位使用的active
  allCategoryActive = 0;
  detailCategoryActive = 0;
  //锚点计时器
  anchorTimeout = null;

  // 专题
  // topicList = [];
  // topicTotal = 0;
  // topicHandle = false;
  // topicCourseList = {};
  // topicLoading = false;

  keywords = "";
  // gradeList = [];
  typeList = [];
  type = null;

  // 不存在子类的另外三大类的背景色拓展
  categoryBackMap = {
    PoliticalEdu: '#fff0ea',
    HomeworkGuide: '',
    LaborEdu: '#f1fff6'
  }

  // ICON_ArrowRight = ICON_ArrowRight;

  get loginStatus() {
    return this.$store.state.AuthModule.loginStatus;
  }

  get ifReviewAccount() {
    return this.$store.state.UserModule.userInfo?.hasReviewAccount;
  }

  get wxBindStatus() {
    if (this.$store.state.UserModule.userInfo.userOauthMap)
      return this.$store.state.UserModule.userInfo.userOauthMap.wx;
    else return false;
  }

  // pageNo = 1;
  // pageSize = 9;
  // total = 0;

  mounted() {
    if (this.$route.query.code && !this.wxBindStatus) {
      this.userCode = this.$route.query.code;
      bindWx({
        code: this.userCode,
      }).then((data) => {
        if (data) {
          this.$message({
            message: "绑定成功！",
            type: "success",
            offset: 120,
            customClass: "errorTips",
          });
          getUserInfo()
            .then((info) => {
              this.$store.commit("UserModule/setUserInfo", info);
              this.$router.replace("/course");
            })
            .catch((err) => console.log(err));
        }
      });
    }
    this.initPage();

    // 监听滚动事件
    window.addEventListener("scroll", this.onScroll);
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  }

  // 滚动监听器
  onScroll() {
    //获取分类的logo部分离顶部的位置
    if (document.getElementById("logo")) {
      const logoFromTop = document
        .getElementById("logo")
        .getBoundingClientRect().top;
      this.logoShow = logoFromTop < 1 ? true : false;
    }
    // 获取所有锚点元素
    const elements = document.querySelectorAll(".anchor-point");
    // 所有锚点元素的 offsetTop
    const offsetTopArr = [];
    const offset = 100;
    elements.forEach((item) => {
      offsetTopArr.push(item.offsetTop);
    });
    // 获取当前文档流的 scrollTop
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    this.toTopShow = scrollTop > 500 ? true : false;
    // 定义当前点亮的导航下标
    let activeIndex = 0;
    for (let n = 0; n < offsetTopArr.length; n++) {
      // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
      // 那么此时导航索引就应该是 n 了
      if (scrollTop >= offsetTopArr[n] - offset) {
        activeIndex = n;
      }
    }
    // 复制下标，此处的6是固定写死的，因为目前的分类只有第一类有6小类
    if (activeIndex >= 6) {
      this.allCategoryActive = activeIndex - 5;
      this.detailCategoryActive = null;
    } else {
      this.allCategoryActive = 0;
      this.detailCategoryActive = activeIndex;
    }
  }

  //锚点跳转
  goAnchor(item) {
    const id =
      item.childrenType.length > 0 ? item.childrenType[0].type : item.type;
    var anchor = document.getElementById(id);
    // anchor.scrollIntoView({
    //   block: "center",
    //   behavior: "smooth",
    // });
    window.scrollTo({
      top: eval(anchor.offsetTop - 52),
      behavior: "smooth",
    });
    this.$store.state.CourseModule.headerShow = false;
    if (this.anchorTimeout) {
      clearTimeout(this.anchorTimeout);
    }
    this.anchorTimeout = setTimeout(() => {
      this.$store.state.CourseModule.headerShow = null;
    }, 1000);
  }

  //返回顶部
  toTop() {
    // chrome
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    // safari
    window.pageYOffset = 0;
  }

  //获取各个分类会用到的文字颜色
  getCategoryColor(type) {
    const colors = {
      MoralCultivation: "#EA6D1A",
      HumanisticCultivation: "#BC5609",
      MathematicalLogic: "#13796A",
      ScientificPractice: "#2330B4",
      AthleticSports: "#0D3E67",
      ArtisticAesthetics: "#A3363A",
    };
    return colors[type];
  }

  getCategoryTip(type) {
    const tips = {
      MoralCultivation: "塑造良好品格 争做阳光少年",
      HumanisticCultivation: "传承中华文明 增强文化自信",
      MathematicalLogic: "锻炼逻辑思维 掌握思辨能力",
      ScientificPractice: "探索科学奥秘 培养求真精神",
      AthleticSports: "提高身体素质 享受运动乐趣",
      ArtisticAesthetics: "感受艺术魅力 提升审美修养",
    };
    return tips[type];
  }

  //作业辅导答疑分类的视频是否展示
  changeDialogShow(bool) {
    this.homeworkVedioShow = bool;
  }

  getCover(covers) {
    if (covers && covers.length > 0) {
      return covers[0];
    } else return "";
  }

  initPage() {
    const that = this;
    if (this.$store.state.AuthModule.initStatus) {
      this.getListInfo();
      this.getAdBanner();
      // if (this.loginStatus) this.getTopicList();
      // getSystemConfig().then((data) => {
      //   this.typeList = data.courseTypes;
      // });
      // getSearchDisc("grade").then((data) => {
      //   this.gradeList = data;
      // });
    } else
      setTimeout(() => {
        that.initPage();
      }, 100);
  }

  // getTopicList() {
  //   const param = {
  //     pageNo: 1,
  //     pageSize: 4,
  //   };
  //   this.topicLoading = true;
  //   getTopicList(param).then((data) => {
  //     this.topicList = data.records;
  //     this.topicTotal = parseInt(data.total);
  //     if (data.records.length > 0) {
  //       this.topicHandle = true;
  //     } else {
  //       this.topicHandle = false;
  //     }
  //     this.topicLoading = false;
  //   });
  // }

  // toMoreTopic() {
  //   this.$router.push("/course/topic");
  // }

  async getAdBanner() {
    const data = await getHomeAdBanner("index_top_banner_teach");
    this.adList = data;
  }

  getGrade(grades) {
    const gradeArr = grades.map((item) => {
      return item.grade;
    });
    return getGrade(gradeArr);
  }

  jumpTo(item) {
    if (item.teachingAuxiliaryId)
      this.$router.push(
        `/course/subjectDetail/${item.id}?teachingAuxiliaryId=${item.teachingAuxiliaryId}&from=1`
      );
    else this.$router.push(`/course/detail/${item.id}?from=1`);
  }

  toAdvertisement(item) {
    let adObj = {
      adText: item.adText,
      name: item.adName,
      startTime: item.startTime,
      endTime: item.endTime,
    };
    adObj = JSON.stringify(adObj);
    sessionStorage.setItem("adObj", adObj);
    this.$router.push({
      path: `/course/advertisementViewer`,
    });
  }

  // localStoreTopicInfo(item) {
  //   const topicStore = JSON.parse(
  //     window.sessionStorage.getItem("topicStore") || "{}"
  //   );
  //   topicStore[item.id] = item;
  //   window.sessionStorage.setItem("topicStore", JSON.stringify(topicStore));
  // }

  // jumpTopic(item) {
  //   this.localStoreTopicInfo(item);
  //   this.$router.push({
  //     path: `/course/topicContent/${item.id}?from=1&title=${encodeURIComponent(
  //       item.topicName
  //     )}&count=${item.courseNum}`,
  //   });
  // }

  getListInfo() {
    let fetch = this.loginStatus ? getHomeCourseList : getGuestHomeCourseList;
    if (this.ifReviewAccount) {
      fetch = getPageList;
    }
    this.courseLoading = true;
    fetch()
      .then((data) => {
        this.courseList = this.ifReviewAccount ? data.records : data;
      })
      .finally(() => {
        this.courseLoading = false;
      });
  }

  handleNavigatorItemClick(type) {
    //type的格式为 四大类,六小类。如果不是六小类则只用四大类即可。
    this.$router.push({
      name: "courseList",
      params: {
        type,
        isNew: true,
      },
    });
  }
  toSearch() {
    if (this.keywords)
      if (this.ifReviewAccount) {
        //电教馆账号搜索往课程列表跳
        this.$router.push({
          name: "courseList",
          query: {
            keywords: this.keywords,
          },
          params: {
            isNew: true,
          },
        });
      } else {
        //普通账号往资源列表跳
        this.$router.push({
          name: "resourceList",
          query: {
            keywords: this.keywords,
          },
        });
      }
  }

  //电教馆专用
  rangeType(item) {
    return getRangeType(item.rangeType);
  }
}
</script>
<style lang="less" scoped>
.main_wrap {
  color: #666666;
  background: #ffffff;
  //补足父元素padding带来的影响
  position: relative;
  bottom: 2rem;
  height: calc(100% + 4rem);
  margin-bottom: -4rem;
  right: 8rem;
  width: calc(100% + 16rem);
  padding: 0 8rem 2rem;
  box-sizing: border-box;
}

.to-top {
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  box-shadow: 0px 4px 15px 0px rgba(31, 31, 31, 0.15);
  border-radius: 10px;
  background: url("~@/assets/images/image_to_top.png") no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  cursor: pointer;
  position: fixed;
  right: 2rem;
  bottom: 15rem;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 0.5rem;
  font-size: 1rem;
  z-index: 99;
  span {
    color: #333333;
    font-weight: 500;
    white-space: nowrap;
  }
}

.guest_tips_wrap {
  display: table;
  width: calc(100% + 16rem);
  position: relative;
  right: 8rem;
  height: fit-content;
  .guest_tips {
    display: inline-flex;
    align-items: center;
    word-break: keep-all;
    justify-content: center;
    font-size: 1.4rem;
    color: #00a2e9;
    background: #d8f0fd;
    width: 100%;
    height: 4rem;
    img {
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 0.7rem;
    }
    a {
      color: #00a2e9;
    }
  }
}
.el-button {
  padding: 1.2rem 2rem;
  font-size: 1.4rem;
}

//v4.3.0
//广告
.advertisement {
  box-sizing: border-box;
  //补足外部框架的padding
  width: calc(100% + 16rem);
  position: relative;
  right: 8rem;

  .advertisement-item {
    height: 100%;
    width: 100%;
    cursor: pointer;
  }

  ::v-deep .el-carousel {
    .el-carousel__container {
      height: 40rem;
      background: skyblue;
      .el-carousel__item {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.category_bar_box {
  position: sticky;
  z-index: 1;
  top: 0;

  .total-category-bar {
    display: flex;
    height: 7rem;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(0deg, #edf1f4 0%, #c9dff4 100%);
    //补足外部框架的padding
    width: calc(100% + 16rem);
    position: relative;
    right: 8rem;
    box-sizing: border-box;
    padding: 0 8rem;

    .category-bar {
      display: flex;
      align-items: center;
      height: 100%;

      .logo {
        width: auto;
        height: 3rem;
        margin-right: 3rem;
      }

      .category-item {
        font-size: 1.6rem;
        font-weight: bold;
        width: 18rem;
        height: 100%;
        box-sizing: border-box;
        //调整文字位置
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .category-icon {
          width: 2.4rem;
          height: 2.4rem;
          margin-right: 0.8rem;
        }
      }
      .active {
        background: url("~@/assets/images/province_category_active.png") center
          center no-repeat;
        background-size: auto 100%;
        color: #2fa5ff;
      }
    }
    .list_tool_bar {
      display: flex;
      align-items: center;
      .list_input_wrap {
        width: 26rem;
        margin-right: 3rem;

        /deep/ .el-input__inner {
          height: 4rem;
          line-height: 4rem;
          border-radius: 0.4rem;
          padding-left: 4.5rem;
          padding-right: 4rem;
          font-size: 1.6rem;
          border: none;
          &::placeholder {
            font-size: 1.6rem;
          }
        }

        /deep/ .el-input__icon {
          font-size: 1.7rem !important;
          font-weight: bold;
          line-height: 4rem;
          height: 4rem;
          cursor: pointer;
          margin: auto 1rem;
        }
      }
      .list_more {
        cursor: pointer;
        text-align: right;
        font-size: 1.6rem;
        height: 4rem;
        line-height: 4rem;
        color: #666666;
      }
    }
  }

  .province-category-bar {
    height: 7rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: #ffffff;
    .category-item {
      color: #666666;
      height: 3.4rem;
      line-height: 3.4rem;
      padding: 0 1.8rem;
      font-size: 1.6rem;
      font-weight: bold;
      margin-right: 1.5rem;
      border-radius: 50px;
      cursor: pointer;
    }
    .active {
      color: #ffffff;
      background: #2fa5ff;
    }
  }
}
//透明占位块
.opacity-bar {
  height: 7rem;
  width: 100%;
  opacity: 0;
  z-index: -99;
}
//电教馆账号 专用
.review-course {
  padding: 5rem 0;

  .list_title_bar {
    display: flex;
    height: 3.7rem;
    justify-content: space-between;
    margin-bottom: 2.5rem;
    .list_logo {
      width: 22.2rem;
      height: 4.4rem;
      margin-top: -0.7rem;
      background: url("~@/assets/images/topic_index_back.png") no-repeat;
      background-size: cover;
      color: #ffffff;
      font-size: 1.8rem;
      font-weight: bold;
      display: flex;
      align-items: center;
      .list_title_icon {
        width: 2rem;
        height: 1.9rem;
        margin: 0 0.6rem 0 1.3rem;
      }
    }
    .list_tool_bar {
      display: flex;
      align-items: center;
      .list_input_wrap {
        width: 26rem;
        margin-right: 1.5rem;
        /deep/.el-icon-search {
          cursor: pointer;
          color: #00a2e9;
        }
      }
      .list_more {
        cursor: pointer;
        text-align: right;
        font-size: 1.6rem;
        height: 3.7rem;
        line-height: 3.7rem;
        color: #00a2e9;
        font-weight: bold;
        .el-icon-arrow-right {
          margin: 0 0.5rem;
          font-weight: bold;
        }
      }
    }
  }

  .main_list {
    margin-top: 1rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: repeat(auto-fill, 15.6rem);
    grid-gap: 2.5rem;
    .course_item {
      overflow: hidden;
      text-decoration: none;
      border: solid 2px #ffffff;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      height: 11.4rem;
      background: #ffffff;
      border-radius: 0.4rem;
      padding: 1.9rem;
      display: flex;
      user-select: none;
      .course_cover_wrap {
        width: 20.4rem;
        border-radius: 0.4rem;
        position: relative;
        overflow: hidden;
        .course_tag {
          display: none;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        .course_cover {
          width: 100%;
          height: 100%;
          transition: all 0.2s;
        }
      }
      .course_info {
        flex: 1;
        margin-left: 1.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0.5rem 0;
        overflow: hidden;
        .course_title {
          font-size: 1.6rem;
          font-weight: bold;
          color: #000000;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .course_intro {
          color: #666666;
          font-size: 1.4rem;
          .course_type {
            margin-bottom: 1rem;
            white-space: nowrap;
          }
        }
      }
    }
    .course_item:hover,
    .course_item:active {
      border: solid 2px #00a2e9;
      box-shadow: 0 0.4rem 2rem 0 rgba(31, 31, 31, 0.1);
      .course_title {
        color: #00a2e9;
      }
      .course_cover {
        transform: scale(1.2);
      }
    }
  }
}
// .topic {
//   margin-top: 5.6rem;
// }
// .topic_title {
//   margin-top: 2.5rem;
//   margin-bottom: 3rem;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   .topic_title_text {
//     position: relative;
//     padding-left: 1.5rem;
//     font-size: 1.8rem;
//     font-weight: 700;
//     color: #000;
//     &:before {
//       position: absolute;
//       top: 0.2rem;
//       left: 0;
//       display: block;
//       content: "";
//       width: 0.5rem;
//       height: 2.2rem;
//       background: #00a2e9;
//       border-radius: 1.5rem;
//     }
//   }
//   .topic_title_more {
//     cursor: pointer;
//     font-size: 1.6rem;
//     font-weight: bold;
//     color: #00a2e9;
//     display: flex;
//     align-items: center;
//     .topic_title_more_icon {
//       margin-left: 0.9rem;
//       width: 0.9rem;
//       height: 1.6rem;
//     }
//   }
// }
// .topic_list {
//   margin-top: 3.2rem;
//   grid-template-columns: 1fr 1fr 1fr 1fr;
//   grid-template-rows: repeat(auto-fill, 34.6rem);
//   .topic_item {
//     text-decoration: none !important;
//   }
// }

//这是省精品课程下面六大类的通用item
.course-category-item {
  width: 100%;
  margin: 3rem 0;
  .course-category-item-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 2rem 0;
    align-items: flex-end;
    border-bottom: 1px #dce3f2 solid;
    margin-bottom: 2rem;
    overflow: visible;
    .icon {
      position: absolute;
      width: 2.5rem;
      height: auto;
      left: 0rem;
      top: 1.4rem;
    }
    .title {
      display: flex;
      align-items: center;
      margin-left: 0.9rem;
      .name {
        font-size: 2.2rem;
        color: #333333;
        font-weight: bold;
        margin-right: 1rem;
      }
      .tip {
        font-size: 1.6rem;
        color: #666666;
        font-weight: normal;
      }
    }
    .more {
      color: #666666;
      font-size: 1.6rem;
      cursor: pointer;
    }
  }
  .category-item-content {
    box-sizing: border-box;
    height: 47rem;
    display: flex;
    .category-wrap {
      height: 100%;
      width: 30rem;
      border-radius: 10px;
      margin-right: 3rem;
      box-sizing: border-box;
      background-repeat: no-repeat !important;
      background-size: 30rem auto !important;
      padding: 3.4rem 2.7rem;
      cursor: pointer;
      .category-name {
        font-size: 3.6rem;
        font-weight: bold;
        margin-bottom: 1.2rem;
      }
      .course-num {
        font-size: 1.8rem;
        font-weight: 400;
      }
    }
    .course-list {
      flex: 1;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(auto-fill, 22rem);
      grid-gap: 3rem;

      .course-item {
        display: flex;
        flex-direction: column;
        cursor: pointer;

        &:hover {
          .course-wrap .course_cover {
            transform: scale(1.2);
          }
          .course-title {
            color: #00a2e9;
          }
        }
        .course-wrap {
          box-sizing: border-box;
          width: 100%;
          height: 17.5rem;
          border-radius: 10px;
          overflow: hidden;

          .course_cover {
            transition: all 0.2s;
            width: 100%;
            height: 100%;
          }
        }
        .course-title {
          margin-top: 1.5rem;
          margin-left: 1rem;
          color: #333333;
          font-size: 1.6rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}

//这是思政教育、作业辅导答疑、劳动教育这三个类的item
.hollow-category-item {
  box-sizing: border-box;
  background-repeat: no-repeat !important;
  background-size: 100% auto !important;
  border-radius: 10px;
  padding: 2rem;
  margin: 3rem 0;

  .hollow-category-item-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .title {
      font-size: 2.2rem;
      color: #333333;
      font-weight: 800;
    }
    .more {
      color: #333333;
      font-size: 1.4rem;
      cursor: pointer;
    }
  }
  .course-list {
    margin-top: 2.4rem;
    padding: 2rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;

    .course-item {
      box-sizing: border-box;
      background: #f5f7fa;
      border-radius: 10px;
      height: 18rem;
      display: flex;
      cursor: pointer;

      &:hover {
        .course-info {
          .course-title {
            color: #00a2e9;
          }
        }
        .course-wrap {
          .course_cover {
            transform: scale(1.2);
          }
        }
      }

      .course-wrap {
        height: 100%;
        width: 32rem;
        box-sizing: border-box;
        margin-right: 2rem;
        border-radius: 10px;
        overflow: hidden;
        .course_cover {
          transition: all 0.2s;
          border-radius: 10px;
          width: 100%;
          height: 100%;
        }
      }
      .course-info {
        flex: 1;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        color: #666666;
        font-size: 1.6rem;
        padding-right: 2rem;
        .course-title {
          color: #000000;
          font-weight: 700;
        }
        .course-grade {
          display: flex;
          .grade {
            margin-right: 4rem;
          }
        }
      }
    }
  }

  .homework-course {
    width: 100%;
    margin-top: 2.4rem;
    border-radius: 10px;
    position: relative;

    .course-wrap {
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
    .video-dialog {
      position: absolute;
      width: 55.1rem;
      height: 30.4rem;
      border-radius: 20px;
      right: 17.2rem;
      top: 4.35rem;
      cursor: pointer;

      .video-bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.5);
        cursor: default;

        .video-element-wrap {
          position: relative;
          top: 50%;
          left: 50%;
          width: 50%;
          height: 50%;
          transform: translate(-50%, -50%);

          .icon-close {
            position: absolute;
            right: -5rem;
            top: -3rem;
            cursor: pointer;
            .course_cover {
              width: 3.5rem;
              height: 3.5rem;
            }
          }

          .video-element {
            width: 100%;
          }
        }
      }
    }
    .course-button {
      position: absolute;
      width: 18.7rem;
      height: 5.4rem;
      border-radius: 50px;
      left: 9.9rem;
      bottom: 7.3rem;
      cursor: pointer;
    }
  }
  .course-empty {
    margin-top: 2.4rem;
    width: 100%;
    height: 25rem;
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    align-items: center;
  }
}

.intro {
  position: relative;
  height: auto;
  width: calc(100% + 16rem);
  top: 2.5rem;
  right: 8rem;
  box-sizing: border-box;
  overflow: hidden;
  .course_cover {
    width: 100%;
    height: 100%;
  }
}

//媒体查询专区
@media screen and (min-width: 1680px) {
  .main_wrap {
    padding: 0 16rem 2rem;
  }
  .guest_tips_wrap {
    width: calc(100% + 32rem);
    right: 16rem;
  }
  .to-top {
    right: 5rem;
    height: 50px;
    width: 50px;
  }
  .advertisement {
    width: calc(100% + 32rem);
    right: 16rem;
  }
  .total-category-bar {
    width: calc(100% + 32rem) !important;
    right: 16rem !important;
    padding: 0 16rem !important;
  }
  .province-category-bar {
    position: relative;
    right: 8rem !important;
    width: calc(100% + 8rem) !important;
    padding: 0 8rem !important;
  }
  .intro {
    width: calc(100% + 32rem) !important;
    right: 16rem !important;
  }
}

@media screen and (max-width: 1280px) {
  .intro {
    margin-top: 15rem;
  }
}
</style>